import React from "react";
import { injectIntl } from "react-intl";
import { Paragraph } from "@trainline/depot-web";
import {
  get12HourTimeFormat,
  ScreenReaderOnly,
  setZeroTimezoneOffset
} from "@trainline-shareable/utils";
import IconCallingPointDestination from "../../../assets/icons/IconCallingPointDestination";
import IconCallingPointOrigin from "../../../assets/icons/IconCallingPointOrigin";
import useJourneyLeg from "../../../hooks/useJourneyLeg";
import useTSICallingPoint from "../../../hooks/useTSICallingPoint";
import useTSIDestinationCallingPointIndex from "../../../hooks/useTSIDestinationCallingPointIndex";
import useTSIOriginCallingPointIndex from "../../../hooks/useTSIOriginCallingPointIndex";
import LivePlatformStatus from "../../LivePlatformStatus";
import LiveTimeStatus from "../../LiveTimeStatus";
import TrackItem from "../../TrackItem";
const isStatusWarning = (callingPoint, isOrigin) => {
  var _a, _b, _c, _d;
  const status = isOrigin ? (_b = (_a = callingPoint.departure) == null ? void 0 : _a.realTime) == null ? void 0 : _b.status : (_d = (_c = callingPoint.arrival) == null ? void 0 : _c.realTime) == null ? void 0 : _d.status;
  return status && ["CANCELLED", "DELAYED", "LATE"].includes(status);
};
const TerminalCallingPoint = ({ type, legId, intl }) => {
  const isOrigin = type === "origin";
  const leg = useJourneyLeg(legId);
  const originCallingPointIndex = useTSIOriginCallingPointIndex(legId);
  const destinationCallingPointIndex = useTSIDestinationCallingPointIndex(legId);
  const callingPointIndex = isOrigin ? originCallingPointIndex : destinationCallingPointIndex;
  const callingPoint = useTSICallingPoint(legId, callingPointIndex);
  const location = isOrigin ? leg.origin : leg.destination;
  const { name: callingPointName = "" } = location || {};
  const { localDepartAt: departAt, localArriveAt: arriveAt } = leg;
  const terminalPointTime = isOrigin ? departAt : arriveAt;
  const callingPointLabelId = isOrigin ? "callingPoint.departsFrom" : "callingPoint.arrivesIn";
  const callingPointLabel = intl.formatMessage({ id: callingPointLabelId }, { callingPoint: callingPointName });
  const isRTDStatusWarning = callingPoint && isStatusWarning(callingPoint, isOrigin);
  const dataType = type === "origin" ? "departure" : "arrival";
  const isUKLocale = intl.locale === "en-gb";
  const isUSLocale = intl.locale === "en-us";
  const accessibleTime = intl.formatTime(new Date(setZeroTimezoneOffset(terminalPointTime)), {
    hour: "numeric",
    minute: "numeric",
    hour12: false,
    timeZone: "UTC"
  });
  return /* @__PURE__ */ React.createElement(TrackItem, null, /* @__PURE__ */ React.createElement(TrackItem.Marker, null, isOrigin ? /* @__PURE__ */ React.createElement(IconCallingPointOrigin, null) : /* @__PURE__ */ React.createElement(IconCallingPointDestination, null)), /* @__PURE__ */ React.createElement(TrackItem.Time, null, /* @__PURE__ */ React.createElement(Paragraph, {
    as: "div",
    typeStyle: "large",
    fontWeight: "bold"
  }, /* @__PURE__ */ React.createElement("time", {
    dateTime: terminalPointTime
  }, (isUKLocale || isUSLocale) && /* @__PURE__ */ React.createElement(ScreenReaderOnly, null, get12HourTimeFormat(accessibleTime)), /* @__PURE__ */ React.createElement("span", {
    "aria-hidden": isUKLocale || isUSLocale
  }, intl.formatTime(new Date(setZeroTimezoneOffset(terminalPointTime)), {
    hour: "numeric",
    minute: "numeric",
    hour12: false,
    timeZone: "UTC"
  })))), /* @__PURE__ */ React.createElement(Paragraph, {
    as: "span",
    color: isRTDStatusWarning ? "negative" : "subdued"
  }, /* @__PURE__ */ React.createElement(LiveTimeStatus, {
    callingPoint,
    type: dataType
  }))), /* @__PURE__ */ React.createElement(TrackItem.Info, null, /* @__PURE__ */ React.createElement(Paragraph, {
    as: "span",
    typeStyle: "large",
    fontWeight: "bold",
    "aria-label": callingPointLabel
  }, callingPointName), /* @__PURE__ */ React.createElement(Paragraph, {
    as: "span",
    color: "subdued",
    fontWeight: "semibold"
  }, /* @__PURE__ */ React.createElement(LivePlatformStatus, {
    callingPoint,
    type: dataType
  }))));
};
var TerminalCallingPoint_default = injectIntl(TerminalCallingPoint);
export {
  TerminalCallingPoint_default as default
};
